import React, { useContext } from 'react';
import { Box, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import Context from './Context'; 

/**
 * NodeWrapper - HOC bọc ngoài giao diện của mọi Custom Node
 * @param {Component} WrappedComponent - Component Node gốc (vd: UserformNode, ApiNode...)
 */
const withNodeWrapper = (WrappedComponent) => {
  return (props) => {
    // props từ ReactFlow truyền xuống bao gồm: id, data, selected, xPos, yPos...
    const { id, data } = props;
    
    // Lấy trạng thái hệ thống từ Context của FlowEditor gửi xuống
    const { viewOnly, flowInstanceId, deleteNodeById,isRunning } = useContext(Context) || {};
    
    // Node bị khóa khi đang chạy runtime debug hoặc ở chế độ chỉ xem (viewOnly)
    const isLocked = viewOnly || isRunning;

    return (
      <Box
        className="flow-node-wrapper"
        sx={{
          position: 'relative', // Làm mốc tọa độ tuyệt đối cho nút xóa
          height: '100%',
          width: '100%',
          // Khi hover vào node, hiển thị nút xóa sắc nét
          '&:hover .delete-node-quick-btn': {
            opacity: 1,
            transform: 'scale(1)',
          }
        }}
      >
        {/* NÚT XÓA NHANH: Chỉ render khi flow mở và ở chế độ chỉnh sửa */}
        {!isLocked && (
          <IconButton
            className="delete-node-quick-btn"
            size="small"
            onClick={(e) => {
              e.stopPropagation(); // Ngăn mở thanh PropertiesBar khi nhấn xóa
              deleteNodeById(id);
            }}
            sx={{
              position: 'absolute',
              top: -12,
              right: -12,
              zIndex: 9999, // Đảm bảo luôn nằm trên các Handles kết nối
              bgcolor: 'error.main',
              color: 'error.contrastText',
              width: 22,
              height: 22,
              opacity: 0, // Mặc định ẩn để tránh rối mắt sơ đồ tổng thể
              transform: 'scale(0.8)',
              transition: 'all 0.15s ease-in-out',
              boxShadow: '0px 2px 4px rgba(0,0,0,0.2)',
              '&:hover': {
                bgcolor: 'error.dark',
                transform: 'scale(1.1)',
              },
              '& svg': {
                fontSize: '13px'
              }
            }}
          >
            <DeleteIcon />
          </IconButton>
        )}

        {/* Render Node thực tế bên trong */}
        <WrappedComponent {...props} />
      </Box>
    );
  };
};

export default withNodeWrapper;